import Menu from "../../Components/Menu";
import Footer from "../../Components/Footer";
import { Container } from "./Styles";
import { MulherCorrendo, Slogan, TestLab } from "../../Components/imgs";

export default function Home() {
	const whatsappMessage = encodeURIComponent(
		"Oii, tudo bem? Vim pelo site e gostaria de mais infomarções sobre os planos 😁"
	);

	const whatsappPremiumMessage = encodeURIComponent(
		"Oii, tudo bem? Vim pelo site e gostaria de saber como funciona o Plano premium"
	);

	const whatsappLink = `https://wa.me/5541984146397?text=${whatsappMessage}%21`;
	const whatsappPremiumLink = `https://wa.me/5541984146397?text=${whatsappPremiumMessage}%21`;

	return (
		<>
			<Menu />
			<Container>
				<div className="top-content">
					<img src={MulherCorrendo} alt="mulher correndo na montanha" />
					<p>
						Cada ser humano possui uma assinatura genética única. Nosso objetivo
						é transformar essa informação em estratégia: para melhorar sua
						performance, otimizar sua nutrição e prevenir lesões. <br />A
						ciência está do seu lado
						<br />
						<strong>
							com a DNA For Performance, vamos juntos usá-la a seu favor.
						</strong>
					</p>
				</div>

				<div className="slogan-wrapper">
					<img
						src={Slogan}
						alt="seu corpo fala, a genetica responde, a performance agradece.	"
					/>
				</div>

				<div id="bottom">
					<p>
						Treinar com mais inteligência, nutrir-se com mais estratégia e
						alcançar resultados reais depende de uma única coisa: 
						<a href="tel:+5541984146397">conhecer o seu DNA.</a>
					</p>
				</div>

				<div className="mid-content">
					<div className="content">
						<img src={TestLab} alt="teste de laboratorio" />
						<p>
							<un>
								A DNA For Performance desenvolveu um painel genético exclusivo
							</un>
							, robusto e de alta precisão, que avalia mais de 400 genes
							específicos para performance física. Nosso painel é construído com
							base nas principais rotas metabólicas envolvidas nos processos
							fisiológicos que influenciam sua força, resistência, recuperação,
							inflamação, resposta hormonal e muito mais.
							<br />
							<br />
							📍 Diferente de testes genéticos genéricos e recreativos, o nosso
							foi desenhado sob medida por especialistas, seguindo as mais
							recentes evidências científicas da genética esportiva e
							nutrigenômica.{" "}
							<un>
								O futuro da performance personalizada começa agora. Começa com
								seu DNA!
							</un>
						</p>
					</div>
				</div>

				<div class="page-wrapper">
					<header class="section-header">
						<h1>Nossos Planos</h1>
						<p>
							Encontre o plano ideal para decodificar seu DNA e otimizar sua
							performance.
						</p>
					</header>

					<main class="cards-container">
						<div class="card">
							<h3>Plano Basic</h3>

							<p class="card-description">
								Painel genético completo com interpretação profissional.
							</p>
							<hr />
							<ul class="features-list">
								<li class="feature-included">
									Painel genético DNA For Performance
								</li>

								<li class="feature-included">
									Interpretação com nutricionista (1h)
								</li>

								<li class="feature-included">
									Interpretação com educador físico (1h)
								</li>

								<li class="feature-excluded">
									Prescrição personalizada de dieta
								</li>

								<li class="feature-excluded">
									Prescrição personalizada de treino
								</li>
							</ul>
							<a href={whatsappLink} class="button button-secondary">
								Saiba Mais
							</a>
						</div>

						<div class="card card-highlighted">
							<div class="badge">RECOMENDADO</div>
							<h3 class="highlight-text">Plano Premium</h3>

							<p class="card-description">
								A solução completa: painel, interpretação e conduta
								personalizada.
							</p>
							<hr />
							<ul class="features-list">
								<li class="feature-included">
									Painel genético DNA For Performance
								</li>

								<li class="feature-included">
									Interpretação com nutricionista (1h)
								</li>

								<li class="feature-included">
									Interpretação com educador físico (1h)
								</li>

								<li class="feature-included">
									Prescrição personalizada de dieta
								</li>

								<li class="feature-included">
									Prescrição personalizada de treino
								</li>
							</ul>
							<a href={whatsappPremiumLink} class="button button-primary">
								Contratar Plano
							</a>
						</div>

						<div class="card">
							<h3>Portabilidade Basic</h3>

							<p class="card-description">
								Traga seu painel e tenha a experiência completa de
								acompanhamento.
							</p>
							<hr />
							<ul class="features-list">
								<li class="feature-included">
									Portabilidade de painel externo
								</li>

								<li class="feature-included">
									Interpretação com nutricionista (1h)
								</li>

								<li class="feature-included">
									Interpretação com educador físico (1h)
								</li>

								<li class="feature-excluded">
									Prescrição personalizada de dieta
								</li>

								<li class="feature-excluded">
									Prescrição personalizada de treino
								</li>
							</ul>
							<a href={whatsappLink} class="button button-secondary">
								Saiba Mais
							</a>
						</div>

						<div class="card">
							<h3>Portabilidade Premium</h3>

							<p class="card-description">
								Traga seu painel e tenha a experiência completa de
								acompanhamento.
							</p>
							<hr />
							<ul class="features-list">
								<li class="feature-included">
									Portabilidade de painel externo
								</li>

								<li class="feature-included">
									Interpretação com nutricionista (1h)
								</li>

								<li class="feature-included">
									Interpretação com educador físico (1h)
								</li>

								<li class="feature-included">
									Prescrição personalizada de dieta
								</li>

								<li class="feature-included">
									Prescrição personalizada de treino
								</li>
							</ul>
							<a href={whatsappLink} class="button button-secondary">
								Saiba Mais
							</a>
						</div>
					</main>
				</div>

				<div className="btn">
					<a id="button" href={whatsappLink} target="_blank" rel="noreferrer">
						Agendar análise
					</a>
				</div>
			</Container>
			<Footer />
		</>
	);
}
